export function getUrlParams(parameter: string) {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  return urlParams.get(parameter)
}

export function isLocal() {
  console.log(window.location)
  return [
    'localhost',
    '127.0.0.1',
    'brikl-3d-studio-playground.netlify.app',
  ].includes(window.location.hostname)
}

export const convertBlobToBase64 = (blob: Blob | File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = reject
    reader.onload = () => {
      resolve(reader.result as string)
    }
    reader.readAsDataURL(blob)
  })

// To detect the JSON part in binary from glb file
export const extractJsonString = (wholeContent: string): string => {
  const content = wholeContent.trim()
  if (content.startsWith('{') || content.startsWith('[')) {
    return content
  }

  let i = 0
  let openedCount = 0
  // Find the word startswith JSON probably somewhere in line 2
  // then move index after that word. It should be at the `{` letter.
  const startIndex = content.indexOf('JSON') + 4
  const startChar = content.charAt(startIndex)

  if (startChar === '{' || startChar === '[') {
    const endChar = startChar === '{' ? '}' : ']'
    i = startIndex + 1
    openedCount = 1

    // get all JSON content by counting the opened blanket
    // to the closed blanket. Overall the counting number
    // at the end should be 0
    while (i < content.length && openedCount !== 0) {
      if (content.charAt(i) === startChar) {
        openedCount++
      } else if (content.charAt(i) === endChar) {
        openedCount--
      }
      i++
    }

    const endIndex = i

    // get the content by substring which from
    // collected startIndex to endIndex
    const json = content.substring(startIndex, endIndex)

    if (json.endsWith(endChar)) {
      return json
    }
  }

  return '{}'
}

export const getForceLandingPage = (): string | null => {
  return getUrlParams('landing')
}
